/**
 * Muscle Grenade — Entrega mismo día Santiago (carrito / drawer → checkout)
 */
(function () {
  const TZ = 'America/Santiago';
  const CUTOFF = 12;
  const ATTR_ENTREGA = 'Entrega';
  const ATTR_FLAG = 'mg_same_day';
  const NOTE_PREFIX = '[MG]';

  function chileParts() {
    const fmt = new Intl.DateTimeFormat('es-CL', {
      timeZone: TZ,
      hour: 'numeric',
      minute: '2-digit',
      hour12: false,
      weekday: 'long',
    });
    const parts = fmt.formatToParts(new Date());
    const get = (t) => parts.find((p) => p.type === t)?.value || '';
    return {
      hour: parseInt(get('hour'), 10) || 0,
      minute: get('minute'),
      weekday: get('weekday'),
      label: fmt.format(new Date()),
    };
  }

  function beforeCutoff() {
    return chileParts().hour < CUTOFF;
  }

  async function updateCart(attributes, note) {
    const body = { attributes };
    if (note !== undefined) body.note = note;
    const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error('No se pudo guardar la opción de entrega');
    return res.json();
  }

  function syncHiddenInputs(forms, entrega, sameDay) {
    forms.forEach((formId) => {
      const form = document.getElementById(formId);
      if (!form) return;
      ['Entrega', 'mg_same_day'].forEach((key) => {
        const name = `attributes[${key}]`;
        let input = form.querySelector(`input[name="${name}"]`);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          form.appendChild(input);
        }
        input.value = key === 'Entrega' ? entrega : sameDay ? 'si' : 'no';
      });
    });
  }

  function mergeNote(existing, entrega) {
    const base = (existing || '').replace(/\[MG\][^\n]*/g, '').trim();
    const line =
      entrega === 'Mismo día Santiago'
        ? `${NOTE_PREFIX} Entrega mismo día Santiago solicitada (antes de 12:00, RM).`
        : `${NOTE_PREFIX} Envío estándar.`;
    return base ? `${base}\n${line}` : line;
  }

  class MGSameDayCheckout extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.formIds = (this.dataset.forms || 'cart,CartDrawer-Form').split(',').map((s) => s.trim());
      this.clockEl = this.querySelector('[data-mg-clock]');
      this.optionsEl = this.querySelector('[data-mg-options]');
      this.afterEl = this.querySelector('[data-mg-after]');
      this.sameDayOption = this.querySelector('[data-mg-option="same_day"]');
      this.radios = this.querySelectorAll('[data-mg-radio]');
      this._saving = false;

      this.applyTimeWindow();
      this.restoreSelection();
      this.bind();
      this.tickClock();
      setInterval(() => this.applyTimeWindow(), 60_000);
      setInterval(() => this.tickClock(), 30_000);
    }

    getForms() {
      return this.formIds.map((id) => document.getElementById(id)).filter(Boolean);
    }

    tickClock() {
      if (!this.clockEl) return;
      const p = chileParts();
      const open = beforeCutoff();
      this.clockEl.textContent = open
        ? `Hora Chile: ${p.label} — mismo día disponible hasta las 12:00`
        : `Hora Chile: ${p.label} — mismo día cerrado (después de las 12:00)`;
    }

    applyTimeWindow() {
      const open = beforeCutoff();
      if (this.sameDayOption) {
        this.sameDayOption.hidden = !open;
        this.sameDayOption.querySelector('input')?.toggleAttribute('disabled', !open);
      }
      if (this.afterEl) this.afterEl.hidden = open;
      if (this.optionsEl) this.optionsEl.classList.toggle('mg-same-day-checkout__options--closed', !open);
      if (!open) {
        const std = this.querySelector('[data-mg-radio="standard"]');
        if (std) std.checked = true;
        this.persist('Envío estándar', false);
      }
    }

    restoreSelection() {
      const initial = this.dataset.initial || '';
      const isSame = /mismo\s*d[ií]a/i.test(initial);
      const radio = this.querySelector(`[data-mg-radio="${isSame ? 'same_day' : 'standard'}"]`);
      if (radio && !radio.disabled) radio.checked = true;
      else {
        const std = this.querySelector('[data-mg-radio="standard"]');
        if (std) std.checked = true;
      }
      syncHiddenInputs(
        this.getForms(),
        isSame && beforeCutoff() ? 'Mismo día Santiago' : initial || 'Envío estándar',
        isSame && beforeCutoff()
      );
    }

    bind() {
      this.radios.forEach((r) => {
        r.addEventListener('change', () => {
          if (!r.checked) return;
          const same = r.dataset.mgRadio === 'same_day';
          this.persist(r.value, same);
        });
      });

      ['checkout', 'CartDrawer-Checkout'].forEach((id) => {
        const btn = document.getElementById(id);
        if (!btn) return;
        btn.addEventListener('click', (e) => this.onCheckout(e, btn), { capture: true });
      });
    }

    async persist(entrega, sameDay) {
      if (this._saving) return;
      this._saving = true;
      syncHiddenInputs(this.getForms(), entrega, sameDay);
      try {
        let note;
        try {
          const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((r) => r.json());
          note = mergeNote(cart.note, entrega);
        } catch {
          note = mergeNote('', entrega);
        }
        await updateCart(
          { [ATTR_ENTREGA]: entrega, [ATTR_FLAG]: sameDay ? 'si' : 'no' },
          note
        );
        this.dataset.initial = entrega;
      } catch (err) {
        console.warn('MG same-day:', err);
      } finally {
        this._saving = false;
      }
    }

    async onCheckout(e, btn) {
      const open = beforeCutoff();
      const selected = this.querySelector('[data-mg-radio]:checked');
      const entrega = selected?.value || 'Envío estándar';
      const sameDay = selected?.dataset.mgRadio === 'same_day' && open;

      if (open && !selected) {
        e.preventDefault();
        e.stopPropagation();
        alert('Elige tipo de entrega: mismo día Santiago o envío estándar.');
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      btn.disabled = true;
      try {
        await this.persist(entrega, sameDay);
        const form = btn.getAttribute('form');
        const el = form ? document.getElementById(form) : btn.closest('form');
        if (el) {
          const checkout = document.createElement('input');
          checkout.type = 'hidden';
          checkout.name = 'checkout';
          checkout.value = '';
          el.appendChild(checkout);
          el.submit();
        }
      } catch {
        btn.disabled = false;
        alert('No pudimos guardar tu opción de entrega. Intenta de nuevo.');
      }
    }
  }

  if (!customElements.get('mg-same-day-checkout')) {
    customElements.define('mg-same-day-checkout', MGSameDayCheckout);
  }

  function showWhenCartHasItems() {
    document.querySelectorAll('mg-same-day-checkout').forEach((el) => {
      const hasItems = !!document.querySelector(
        '#CartDrawer-CartItems .cart-item, #main-cart-items .cart-item, cart-drawer-items .cart-item'
      );
      el.hidden = !hasItems;
    });
  }

  document.addEventListener('cart:refresh', showWhenCartHasItems);
  document.addEventListener('DOMContentLoaded', showWhenCartHasItems);

  const obs = new MutationObserver(showWhenCartHasItems);
  document.addEventListener('DOMContentLoaded', () => {
    const drawer = document.getElementById('CartDrawer-CartItems');
    if (drawer) obs.observe(drawer, { childList: true, subtree: true });
  });
})();